import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './ComplaintManagement.css';
import ComplaintTypesList from './ComplaintTypesList';

const tiles = [
  {
    icon: '📝',
    title: 'Add a Complaint',
    description: 'Report a new complaint from paying guest or staff',
    url: 'add',
    access_roles: ['RT_Admin'] // Only admin can add complaints
  },
  {
    icon: '👤',
    title: 'My Assigned Complaints',
    description: 'View complaints assigned to me',
    url: 'my-assigned',
    access_roles: ['RT_Staff'] // Only staff can see their assigned complaints
  },
  {
    icon: '📂',
    title: 'View Open Complaints',
    description: 'See all pending and in-progress complaints',
    url: 'view',
    access_roles: ['RT_Admin', 'RT_Staff'] // Default to admin
  },
  {
    icon: '📋',
    title: 'View Complaints History',
    description: 'Browse all resolved and closed complaints',
    url: 'history',
    access_roles: ['RT_Admin', 'RT_Staff'] // Default to admin
  }
];

const ComplaintManagement = () => {
  const [activeTile, setActiveTile] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleTileClick = (tile) => {
    setActiveTile(tile);
  };

  if (activeTile === 'types') {
    return <ComplaintTypesList onBack={() => setActiveTile(null)} />;
  }

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Complaint Management</h2>
        </div>
        <div className="rt-main-section">
          <div className="rt-tiles-grid">
            {tiles.map((tile, idx) => (
              <Tile
                key={idx}
                title={tile.title}
                icon={tile.icon}
                description={tile.description}
                access_roles={tile.access_roles}
                onClick={() => tile.url && navigate(tile.url)}
                tabIndex={0}
                role="button"
                onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
              />
            ))}
            <Tile
              title="Complaint Types"
              description="View, add, edit, and delete complaint types."
              icon="🔧"
              access_roles={['RT_Admin']} // Default to admin for complaint types
              onClick={() => handleTileClick('types')}
              tabIndex={0}
              role="button"
              onKeyPress={e => { if (e.key === 'Enter') handleTileClick('types'); }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintManagement;
